import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=c6163a5c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=c6163a5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6163a5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6163a5c')) {
      api.createRecord('c6163a5c', component.options)
    } else {
      api.reload('c6163a5c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=c6163a5c&scoped=true&", function () {
      api.rerender('c6163a5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28UMQwaCM5jwA/JS/comp/DocBox.vue"
export default component.exports